import { useToast } from 'vue-toastification'

const usePatientAppointmentRequest = () => {

    const targetDoctorId = useState("targetDoctorId", () => "")
    const targetFacilityId = useState("targetFacilityId", () => "")
    const targetDateTime = useState("targetDateTime", () => "")
    const confirmationCode = useState("confirmationCode", () => "-")
    const ModalShow = useState("ModalShow", ()=> false)
    const setModalShow = (Input) =>{
        ModalShow.value = Input
    }
    
    const ModalState = useState("ModalState",()=> "default")
    const setModalState = (Input) => {
        ModalState.value = Input
    }

    const ModalMessage = useState("ModalMessage", () => "")
    const setModalMessage = (Input) => {
        ModalMessage.value = Input
    }


    const FormStatus = useState("FormStatus", () => "ok")
    const setFormStatus = (Input) => {
        FormStatus.value = Input
    }

    const FormStatusText = useState("FormStatusText", () => "")
    const setFormStatusText = (Input) => {
        FormStatus.value = Input
    }

    const ptData = useState("ptData", () => ({
        pt_is_first_visit: false,
        pt_is_anonymous_visit: false,
        pt_dob: "",
        pt_name: "",
        pt_email: "",
        pt_phone: "",
        pt_visit_reason: "unselected",
        pt_language_preference: "unselected",
        pt_use_medical_insurance: true,
        pt_try_different_provider: true,
        pt_insurance_company_name: "",
        pt_insurance_member_id: "",
        pt_other_request: "",
        pt_email_sms_consent: false,
        pt_save_info: false,
        pt_term_accepted: false
    }))

    const selectedApptDate = useState('selectedApptDate', ()=>"")
    const SetselectedApptDate = (Input) => {
        selectedApptDate.value = Input
    }
    const AppointmentSlots = useState('AppointmentSlots', ()=>[ ])
    const setAppointmentSlots = (Input) =>{
        AppointmentSlots.value = Input
    }

    const selectedAppointmentSlot = useState('selectedAppointmentSlot', ()=>"")
    const setSelectedAppointmentSlot = (Input) => {
        selectedAppointmentSlot.value = Input
    }

    const getAppointmentSlots = async (enableModal) => {
        
        console.debug("Getting Appointment Slots for: ", selectedApptDate.value)
        // Clear Existing Appointment Slot
        // setSelectedAppointmentSlot("")
        if (enableModal){
            setModalState('slot-retrieve-wait')
            
        }

        // console.debug("Clearing Appointment Slots")
        // setAppointmentSlots([])
        try{
            let resp = await $fetch(`/api/doctor/getApptSlots?target_date_str=${selectedApptDate.value}&target_doctor_id=${targetDoctorId.value}&target_facility_id=${targetFacilityId.value}}`)
            console.debug ("Received Appt Data from Server:",resp)


            if (resp == 'Error: Invalid Request')
            {   
                console.error("Error Getting Appointment Data, Skipping...")
                return
            }
            setAppointmentSlots(resp)

            if (enableModal){
                
                setModalShow(false)
            }
            
        }
        catch(e){
            console.error("Error Getting Appointment Data", e)
            setModalState('error')
            setModalShow(true)
        }
        
        
    }

    const ValidateRequest = () => {
        var result = {status: 'ok', messages: ""}
        if(ptData.value.pt_phone == ""){
            result.status = 'error'
            result.messages = result.messages + " " + "电话号码不能为空" + "\n"
        }
        if(ptData.value.pt_term_accepted == false){
            result.status = 'error'
            result.messages = result.messages + " " + "请阅读并同意条款" + "\n"
        }
        if(!ptData.value.pt_is_anonymous_visit){
            if (ptData.value.pt_name == ""){
                result.status = 'error'
                result.messages = result.messages + " " + "姓名不能为空" + "\n"
            }
            if (ptData.value.pt_dob == ""){
                result.status = 'error'
                result.messages = result.messages + " " + "出生日期不能为空" + "\n"
            }
        }
        if (ptData.value.pt_use_medical_insurance){
            if(ptData.value.pt_insurance_company_name == ""){
                result.status = 'error'
                result.messages = result.messages + " " + "请填写保险公司名称" + "\n"
            }
        }
        if (ptData.value.pt_visit_reason == "unselected"){
            result.status = 'error'
            result.messages = result.messages + " " + "请选择就诊原因" + "\n"
        }
        return result

    }
    
    const submitAppointmentRequest = async () => {
        const toast = useToast()

        // toast.error("十分抱歉，系统维护中，当前无法提交预约，请稍后再试")

        if (selectedAppointmentSlot.value == ""){
            toast.error("请选择预约时间")
            return
        }
        const result = await ValidateRequest()
        if (result.status == 'error'){
            setModalState('error')
            setModalShow(true)
            toast.error("无法提交，请检查信息："+ "\n" + result.messages)
            return
        }
        const payload = {
            ...ptData.value,
            target_doctor_id: targetDoctorId.value,
            target_facility_id: targetFacilityId.value,
            selected_appt_date_time: selectedAppointmentSlot.value,
        }
        setModalState('appt-submit-wait')
        setModalShow(true)
        const resp = await $fetch('/api/doctor/requestAppt', {
            method: 'POST',
            body: JSON.stringify({
                payload: payload
            })
        })
        console.debug("Submit Appt: Received Response from Server:", resp)
        if (resp.status == 'ok')
        {   
            confirmationCode.value = resp.result.ID
            toast.success("提交成功，请等待诊所确认")
            setModalState('appt-submit-success')
            setModalShow(true)
            
        }
        else{
            toast.error("十分抱歉，系统维护中，当前无法提交预约，请稍后再试")
            setModalState('error')
            setModalShow(true)
        }
    }


    return {
        targetDoctorId, targetFacilityId, targetDateTime, ptData, submitAppointmentRequest, selectedApptDate, SetselectedApptDate, getAppointmentSlots, AppointmentSlots, setAppointmentSlots, selectedAppointmentSlot, setSelectedAppointmentSlot, ModalShow,
        setModalShow,
        ModalState,
        setModalState,
        ModalMessage,
        setModalMessage,
        confirmationCode,
    }

}

export default usePatientAppointmentRequest